import React from "react";

import { makeStyles } from "tss-react/mui";
import { Grid, TextField, Typography } from "@mui/material";
import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  buttonText: "Continuar",
  nextScreen: "building-tension",
  skipTo: "building-tension",
};

const useStyles = makeStyles()((theme) => ({
  instructionsOuter: {
    backgroundColor: theme.palette.backgrounds.primary,
    padding: theme.spacing(2),
    borderRadius: "12px",
  },
}));

export const ElectricalCapacity = ({ history }) => {
  const { classes } = useStyles();
  const { amperage, setAmperage } = useGreenEnergyContext();
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleButton = () => {
    if (amperage) {
      history.push(FRAME_DATA.nextScreen);
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleButton}>
      <BlockStandard hideDivider>
        <Typography variant="h2">
          Qual capacidade do quadro elétrico geral?
        </Typography>
        <TextField
          value={amperage}
          onChange={({ target }) => {
            setAmperage(target.value);
          }}
          variant="outlined"
          label="Amperagem"
          error={hasFormError}
        />
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography
          variant="subtitle1"
          color="secondary.main"
          fontWeight="bold"
        >
          Como saber a amperagem do quadro
          <Typography>
            A imagem abaixo ilustra onde é possível localizar essa informação
          </Typography>
        </Typography>

        <Grid item container className={classes.instructionsOuter}>
          <img
            src="/static/img/electrical-capacity/instructions.png"
            alt=""
            style={{ width: "100%" }}
          />
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
